// extracted by mini-css-extract-plugin
module.exports = {"go_back":"styles_go_back__3DJ3i","go_back_content":"styles_go_back_content__3m3PQ"};